/* Skilljar is a deprecated platform that was used for teacher training. These unique ids are kept so as to be able to
 * acknowledge educators that completed training via skilljar before it was deprecated */
export enum SKILLJAR_ID {
  CLASS_CONTENT_POLICIES_ACTIVITY_ID = "2204u7hul17ew",
  SAFETY_AND_PRIVACY_ACTIVITY_ID = "1w400bup12ixj",
  SAFETY_AND_PRIVACY_ORG_ADMIN_ACTIVITY_ID = "25ig3933t20nw",
  CLASS_CONTENT_POLICIES_ORG_ADMIN_ACTIVITY_ID = "385u5tgrimjec",
  SAFETY_AND_PRIVACY_ORG_TEACHER_ACTIVITY_ID = "28qr7m2qaxlgk",
  ONLINE_TOOLS_ORG_TEACHER_ACTIVITY_ID = "1rdd2s3rzzpqa",
}
